import { CommonModule, Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { getFromStorage } from '../../helpers/storageUtils';
import { CONSULTA_RUNT, DATOS_RESTANTES, DEFAULT, LOADER_MOTO, ONEROSO, PLANES } from '../../routes.constans';
import { ACCESORIES, CEROKM, FINANCIED } from '../../shared/onerous/onerous-pages.constants';
import { AnuncioComponent } from '../anuncio/anuncio.component';

const cleanRoute = (route: string): string => (route ? route.replace(/^\/+|\/+$/g, '') : '');

@Component({
  selector: 'banner-app',
  standalone: true,
  imports: [CommonModule, AnuncioComponent],
  templateUrl: './banner-app.component.html',
  styleUrl: './banner-app.component.scss',
})
export class BannerAppComponent implements OnInit {
  swCarga = 0;
  private startDate: Date = new Date(environment.bannerStartDate);
  private endDate: Date = new Date(environment.bannerEndDate);
  showBanner: boolean = environment.bannerEnabled && this.isWithinActivePeriod();

  @Input() retroSelected!: boolean;
  @Input() Loader!: boolean;
  @Input() Ppal!: boolean;
  @Input() Fixtop = 'fixed-top';
  @Input() infoDueno!: boolean;
  @Input() showPromo = false;

  private baseOnerous = cleanRoute(ONEROSO);
  private basePlanes = cleanRoute(PLANES);

  private readonly onerousSelectionStepsMap: Record<string, string[]> = {
    '0km': [cleanRoute(CEROKM)],
    'accesorios': [cleanRoute(ACCESORIES)],
    'prenda': [cleanRoute(FINANCIED)],
    '0kmaccesorios': [cleanRoute(ACCESORIES), cleanRoute(CEROKM)],
    'prendaaccesorios': [cleanRoute(FINANCIED), cleanRoute(ACCESORIES)],
    '0kmprenda': [cleanRoute(FINANCIED), cleanRoute(CEROKM)],
    'full': [cleanRoute(FINANCIED), cleanRoute(ACCESORIES), cleanRoute(CEROKM)],
  };

  private flowNavigationMap!: Record<string, string>;

  constructor(
    private router: Router,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.flowNavigationMap = {
      [cleanRoute(DATOS_RESTANTES)]: this.basePlanes,
      [cleanRoute(LOADER_MOTO)]: this.baseOnerous,
      [this.baseOnerous]: cleanRoute(CONSULTA_RUNT),
      [cleanRoute(CONSULTA_RUNT)]: cleanRoute(DEFAULT) || 'seguros/movilidad/motos/cotizador',
    };
  }

  private isWithinActivePeriod(): boolean {
    const now = new Date();
    return now >= this.startDate && now <= this.endDate;
  }

  regresarPagina(): void {
    const currentPath = cleanRoute(this.router.url.split('?')[0].split(';')[0]);
    const rawSelection = getFromStorage<string>('OnerousSelection', 'session') || '';
    const selection = String(rawSelection).trim().toLowerCase();

    console.log('🔙 Ruta actual:', currentPath, '| Selection:', selection);

    const targetRoute = this.resolvePreviousRoute(currentPath, selection);

    if (targetRoute) {
      console.log('✅ Navegando a:', targetRoute);
      this.router.navigate([`/${targetRoute}`]);
    } else if (window.history.length <= 1) {
      console.log('⚠️ Sin historial, ir a Default');
      this.router.navigate([`/${cleanRoute(DEFAULT)}`]);
    } else {
      console.log('🔄 Ejecutando location.back()');
      this.location.back();
    }
  }

  private resolvePreviousRoute(currentPath: string, selection: string): string | null {
    const activeSubSteps = this.onerousSelectionStepsMap[selection] || [];

    if (currentPath === this.basePlanes) {
      const lastStep = activeSubSteps[activeSubSteps.length - 1];
      return lastStep ? `${this.baseOnerous}/${lastStep}` : this.baseOnerous;
    }

    if (currentPath.startsWith(`${this.baseOnerous}/`)) {
      const currentSubRoute = cleanRoute(currentPath.replace(this.baseOnerous, ''));
      const currentIndex = activeSubSteps.indexOf(currentSubRoute);

      if (currentIndex > 0) {
        // Devuelve el sub-paso anterior dentro de la secuencia elegida
        return `${this.baseOnerous}/${activeSubSteps[currentIndex - 1]}`;
      }

      return this.baseOnerous;
    }

    return this.flowNavigationMap[currentPath] || null;
  }
}